import { render, staticRenderFns } from "./PolicyCookies.vue?vue&type=template&id=8b40e816&scoped=true&"
import script from "./PolicyCookies.vue?vue&type=script&lang=js&"
export * from "./PolicyCookies.vue?vue&type=script&lang=js&"
import style0 from "./PolicyCookies.vue?vue&type=style&index=0&id=8b40e816&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b40e816",
  null
  
)

export default component.exports